import ax from "axios";

ax.defaults.headers.post["Content-Type"] = "application/json";
ax.defaults.validateStatus = (status) => status >= 200 && status < 500; // default

const headers = {};

const axios = ax.create({
  baseURL: `${process.env.NEXT_PUBLIC_BACKEND_URL}/api`,
  headers,
});

axios.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => Promise.reject(error)
);

export default axios;
